// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bandeja-66-item-dimensiones{position:absolute;bottom:0;width:100%;text-align:center}.img66{top:0;left:-38px;position:absolute;overflow:hidden}.container66,.img66{height:200px;width:200px}.container66{position:relative}", ""]);
// Exports
module.exports = exports;
